/**
 * South Sudanese pound.
 */
export var SSP = {
  code: 'SSP',
  base: 10,
  exponent: 2
};